<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-card>
      <v-card-title>Create item</v-card-title>
      <v-divider/>
        <v-form v-model="valid" immediate ref="form" class="mt-4">
          <v-container>
            <v-row dense>
              <v-col>
                <v-text-field label="Name" v-model="item.name" :rules="[fieldRules.required,fieldRules.maxLength(100)]" outlined dense :counter="100" autofocus/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="7">
                <v-autocomplete v-model="item.type" outlined dense label="Type" @change="item.lotTracking=item.type==='Item'"
                                :items="[{text:'Item',value:'Item'},{text:'Item (not tracked)',value:'NonTracking'},{text:'Service',value:'Service'}]"
                                :hint="itemHint" persistent-hint
                                :disabled="type!==undefined"/>
              </v-col>
              <v-col>
                <v-checkbox label="Lot tracking" v-model="item.lotTracking" dense class="mt-1" :disabled="item.type!=='Item'"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" sm="5">
                <v-text-field label="Tracking units" v-model="item.trackUnits" :rules="[fieldRules.maxLength(10)]" :counter="10" outlined dense/>
              </v-col>
              <v-col cols="6" sm="5">
                <v-select label="Decimal places" v-model="item.precision" :items="[0,1,2,3]" outlined dense hint="for quantities"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <inventory-categories-select v-model="item.categoryId" label="Category" type="Item" hint/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
        <v-btn color="primary" @click="create()" :loading="busy">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {format} from 'date-fns'
import InventoryCategoriesSelect from '@/views/inventory/categories/InventoryCategoriesSelect'

export default {
  name: 'InventoryItemsQuickCreate',
  components: {InventoryCategoriesSelect},
	props: {
    value: {type:Boolean,required:true},
    type: {type:String, required:false},
    sold: {type:Boolean,required:false,default:false},
    defaultName: {type:String, required:false, default:''}
  },
  data() {
    return {
      valid: true,
      show: false,
      companyAccounts: {},
      item: {type:this.type||'Item',name:'',sku:'',active:true,lotTracking:true,location:'',
              trackUnits:'items',precision:0,reorderPoint:-1,allowNegativeInventory:false,categoryId:null,
              inventoryAccountRef:'',incomeAccountRef:'',cogAccountRef:'',
              buyingUnits:'items',convertToTracking:1,weight:0,upc:'',reorderQuantity:0,reorderDays:0,reorderBusinessDays:false,
              buyingDescription:'',buyingPrecision:0,vendors:[],preferredVendorId:null,
              sold:this.sold,sellingDescription:'',defaultPrice:0,defaultTaxId:null,customers:[],
              usageCost:0,commissionExempt:false,
              assembled:false,bom:[],
              initial:[],initialAsof:format(new Date(), 'yyyy-MM-dd HH:mm:ss')},
      busy: false
    }
  },
  computed: {
    itemHint() {
      if (this.item.type === 'Item')
        return 'Quantities are tracked';
      if (this.item.type === 'NonTracking')
        return 'Quantities are not tracked';
      return '';
    }
  },
  async created() {
    const results = await this.$apiCall(`query InventoryItemsQuickCreate {
                                          companyAccounts {
                                            itemInventory,itemCOG,itemIncome,
                                            nonInventoryUsage,nonInventoryIncome,nonInventoryExpense,
                                            serviceUsage,serviceIncome,serviceExpense
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.companyAccounts = results.data.companyAccounts;
    this.item.lotTracking = this.item.type==='Item';
  },
  watch: {
    value() {
      this.item.name = this.defaultName;
      this.item.trackUnits = 'items';
      this.show = this.value;
    },
    type() {
      this.item.type = this.type;
      this.item.lotTracking = this.item.type==='Item';
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.item.buyingUnits = this.item.trackUnits;
      if (this.item.type === 'Item')
        Object.assign(this.item, {inventoryAccountRef:this.companyAccounts.itemInventory,incomeAccountRef:this.companyAccounts.itemIncome,cogAccountRef:this.companyAccounts.itemCOG});
      else if (this.item.type === 'NonTracking')
        Object.assign(this.item, {inventoryAccountRef:this.companyAccounts.nonInventoryUsage,incomeAccountRef:this.companyAccounts.nonInventoryIncome,cogAccountRef:this.companyAccounts.nonInventoryExpense});
      else if (this.item.type === 'Service')
        Object.assign(this.item, {inventoryAccountRef:this.companyAccounts.serviceUsage,incomeAccountRef:this.companyAccounts.serviceIncome,cogAccountRef:this.companyAccounts.serviceExpense});
      this.busy = true;
      const results = await this.$apiCall(`mutation InventoryItemsQuickCreate($input: ItemInput!) {
                                            itemCreate(input:$input) {id,name,type,trackUnits,lotTracking,precision,category{id},active,sold}
                                          }`,
                                          {input:this.item});
      this.busy = false;
      if (!results.error) {
        this.show = false;
        this.$store.commit('itemAdd', results.data.itemCreate);
        this.$emit('input', false);
        this.$emit('create',results.data.itemCreate);
      }
    },
  }
}
</script>
